import React from "react";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function YouTubeComponent() {
  const videos = [
    {
      id: "qaa1xu4YOdM",
      title:
        "An Era Of Transformation: Exclusive Interview With Our Departing Principal ",
      description:
        "The Vidyaloka College Old Boys' Association proudly presents an exclusive interview with our departing Principal, reflecting on a remarkable 13-year tenure that transformed our alma mater into what it is today.",
    },
    {
      id: "02oHG7Cmppw",
      title: "විද්‍යාලෝක විද්‍යා අංශයේ ආරම්භය හා සබැඳි සුන්දර කතා - 2",
      description:
        "වසර අසූපහක ඉතිහාසය අභිමුව අතීත තොරතුරු ගවේෂණය කරනු වස් විද්‍යාලෝක විද්‍යාලයීය ආදී ශිෂ්‍ය සංගමය, හරි අපූරු වැඩකට මුල පුරනු ලැබුවා. ඒ තමයි අතීතාවර්ජනයේ සෞන්දර්ය වර්තමානයට කැඳවමින් යුග කිහිපයක අනුස්මරණීය චරිත සමග සිදු කරනු ලබන විද්‍යුත් සාකච්ඡාව",
    },
    {
      id: "XE5iKdePYKA",
      title: "විද්‍යාලෝක විද්‍යා අංශයේ ආරම්භය හා සබැඳි සුන්දර කතා - 1",
      description:
        "වසර අසූපහක ඉතිහාසය අභිමුව අතීත තොරතුරු ගවේෂණය කරනු වස් විද්‍යාලෝක විද්‍යාලයීය ආදී ශිෂ්‍ය සංගමය, හරි අපූරු වැඩකට මුල පුරනු ලැබුවා. ඒ තමයි අතීතාවර්ජනයේ සෞන්දර්ය වර්තමානයට කැඳවමින් යුග කිහිපයක අනුස්මරණීය චරිත සමග සිදු කරනු ලබන විද්‍යුත් සාකච්ඡාව",
    },
    {
      id: "GF8l0ENwsxg",
      title: "Proudly Launching The Vidyaloka College OBA Online Membership",
      description:
        "විද්‍යාලෝක විද්‍යාලයීය ආදි ශිෂ්‍ය සංගමයේ සාමාජිකත්වය ලබා ගැනීමේ හැකියාව වඩාත් පහසු කරමින් මාර්ග ගත ක්‍රමය ඔස්සේ සාමාජිකත්වය ලබා ගැනීමේ ව්‍යාපෘතිය පසුගියදා ආරම්භ කළා. ආදි ශිෂ්‍ය සංගම් කාර්යාලය කේන්ද්‍ර කර ගනිමින් සංවිධානය කළ කුඩා හමුවකදී දෙස් විදෙස්  පදිංචිය සහිත ආදි ශිෂ්‍යයන් බොහෝ දෙනෙක් මෙම පහසුකම අත්විඳිමින් සිය සාමාජිකත්වය ලබා ගැනීමට කටයුතු කළා...",
    },
  ];

  return (
    <div
      className="rounded-3 border-vcg-muted p-4 p-lg-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-right"
    >
      <div className="mb-4 text-center">
        <FontAwesomeIcon
          icon={faYoutube}
          size="3x"
          className="text-danger mb-3"
        />

        <h3 className="fw-bold">Official YouTube Channel</h3>

        <p
          className="text-muted mb-0 mx-auto"
          style={{
            maxWidth: "750px",
            lineHeight: "1.7",
          }}
        >
          Watch the latest events, interviews, celebrations, school activities,
          and community initiatives from the Vidyaloka College Galle Old Boys'
          Association.
        </p>
      </div>

      <div className="row g-4">
        {videos.map((video) => (
          <div className="col-lg-6" key={video.id}>
            <div
              className="border rounded-3 p-3 h-100"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <div className="ratio ratio-16x9 rounded overflow-hidden">
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>

              <div className="mt-3">
                <h5 className="fw-bold">{video.title}</h5>

                <p
                  className="text-muted small mb-0"
                  style={{
                    textAlign: "justify",
                    lineHeight: "1.7",
                  }}
                >
                  {video.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-5">
        <a
          href="https://www.youtube.com/@OldBoysAssociationVCG"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-danger px-4 py-2"
        >
          <FontAwesomeIcon icon={faYoutube} className="me-2" />
          Visit Our YouTube Channel
        </a>
      </div>
    </div>
  );
}
